/* eslint-disable no-restricted-globals */
import React from 'react'
import { TableIncrementalStep } from '../../../../../components/common/table'

const DieCuttingCostTable = ({
  data = {},
  onChange,
}) => {
  const handleOnSubmitEditRow = (key, value) => {
    const tmp = [...data.dieCuttingOperationCost]
    const tmpValue = value
    if (tmpValue.column1 === null || isNaN(tmpValue.column1)) tmpValue.column1 = 0
    if (tmpValue.column2 === null || isNaN(tmpValue.column2)) tmpValue.column2 = 0
    if (tmpValue.column3 === null || isNaN(tmpValue.column3)) tmpValue.column3 = 0
    if (tmpValue.column4 === null || isNaN(tmpValue.column4)) tmpValue.column4 = 0
    if (tmpValue.column5 === null || isNaN(tmpValue.column5)) tmpValue.column5 = 0
    tmp[key] = tmpValue
    onChange({ ...data, dieCuttingOperationCost: tmp })
  }

  const handleOnSubmitEditColumn = (value, rows) => {
    onChange({ ...data, headerDieCuttingOperationCost: value, dieCuttingOperationCost: rows })
  }

  const handleOnSubmitNewColumn = (value, index) => {
    const tmpHeaders = [...data.headerDieCuttingOperationCost].map((column, i) => {
      let colDataIndex
      if (/column*/.test(column.dataIndex)) {
        colDataIndex = `column${i}`
      } else {
        colDataIndex = column.dataIndex
      }
      return {
        ...column,
        dataIndex: colDataIndex,
        key: colDataIndex,
      }
    })
    const tmpDatas = [...data.dieCuttingOperationCost].map((row, i) => ({
      ...row,
      [index]: 0,
    }))
    tmpHeaders.push({
      title: value,
      dataIndex: index,
      key: index,
      inputType: 'number',
      editable: true,
      editColumn: true,
      alignCell: 'center',
    })
    onChange({ ...data, headerDieCuttingOperationCost: tmpHeaders, dieCuttingOperationCost: tmpDatas })
  }

  return (
    <TableIncrementalStep
      title="ต้นทุนการปั๊มตัด (Die-cutting Operation Costs)"
      onSubmitEditRow={handleOnSubmitEditRow}
      onSubmitEditColumn={handleOnSubmitEditColumn}
      onSubmitNewColumn={handleOnSubmitNewColumn}
      headers={data.headerDieCuttingOperationCost}
      data={data.dieCuttingOperationCost}
    />
  )
}

export default DieCuttingCostTable
